module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Privacy Preference',
        save: 'Save Preferences',
        allowCookies: 'Allow advertising cookies',
        disallowCookies: 'Do not allow advertising cookies'
    };

    return resources[label];
};
